/** Chuỗi màn "Quên mã" + "Chọn tiệm" (kế hoạch docs/plans/khoi-phuc-dang-nhap.md, ADR-071). */
export const Q = {
  nutQuen: 'Quên mã đăng nhập?',
  tieuDe: 'Quên mã đăng nhập',
  hoiVai: 'Bạn là ai trong tiệm?',
  laNhanVien: 'Tôi là nhân viên',
  laChu: 'Tôi là chủ tiệm',
  quayLai: 'Quay lại đăng nhập',

  nhanVienTieuDe: 'Nhờ chủ tiệm đặt lại mã',
  nhanVienBuoc: [
    'Chủ tiệm mở Cấu hình → Nhân viên.',
    'Bấm “Sửa” ở dòng tên bạn, rồi bấm “Đặt mã đăng nhập”.',
    'Chủ tiệm đọc mã mới cho bạn. Lần vào đầu, bạn đổi sang mã riêng của mình.',
  ],
  nhanVienXong: 'Đã có mã mới — đăng nhập',

  chuTieuDe: 'SAPA giúp bạn lấy lại mã',
  chuCach:
    'Bạn nhắn hoặc gọi SAPA. Để giữ an toàn cho tiệm, SAPA sẽ gọi lại đúng số điện thoại bạn đã dùng để mở tiệm, rồi gửi bạn mã mới.',
  chuDoiSo: 'Mất số cũ hoặc đã đổi số? Bạn nói luôn khi nhắn, SAPA sẽ hướng dẫn cách xác minh.',
  nhanZalo: 'Nhắn SAPA qua Zalo',
  goi: (so: string) => `Gọi SAPA ${so}`,
  chuaCoSo: 'Bạn liên hệ người đã giới thiệu SAPA cho tiệm để được giúp nhé.',

  // Lấy lại mã qua Zalo (ADR-072)
  zaloTieuDe: 'Lấy lại mã qua Zalo',
  zaloGoiY: 'Nhập số điện thoại bạn dùng để mở tiệm. SAPA gửi mã 6 số vào Zalo của số đó.',
  guiMa: 'Gửi mã qua Zalo',
  dangGui: 'Đang gửi…',
  nhapMaTieuDe: 'Nhập mã trong Zalo',
  daGui: (so: string) =>
    `Nếu ${so} là số chủ tiệm trên SAPA, Zalo của số đó sẽ nhận tin "Mã xác thực" trong khoảng 1 phút.`,
  oMa: 'Mã 6 số',
  xacNhan: 'Xác nhận',
  guiLai: 'Gửi lại mã',
  guiLaiSau: (giay: number) => `Gửi lại sau ${giay} giây`,
  doiSoKhac: 'Nhập số khác',
  maMoiTieuDe: 'Đặt mã đăng nhập mới',
  maMoiChoTiem: (ds: string) => `Mã mới dùng để vào: ${ds}.`,
  // SEC-6: số là chủ ≥ 2 tiệm thì tự CHỌN tiệm cần đặt lại (không chọn sẵn, trừ tiệm máy này đã nhớ).
  // Tên khoá KHÁC `chonTiemTieuDe` / `chonTiemGoiY` bên dưới (màn "Bạn vào tiệm nào?" lúc đăng nhập).
  datMaChonTieuDe: 'Đặt mã cho tiệm nào?',
  datMaChonGoiY:
    'Chọn ít nhất một tiệm. Chỉ chọn tiệm của bạn. Thấy tiệm lạ mang số của bạn thì đừng chọn, và gọi SAPA giúp nhé.',
  datMaMaTiem: (ma: string) => `Mã tiệm ${ma}`,
  datMaMoNgay: (ngay: string) =>
    `Mở ngày ${ngay.slice(8, 10)}/${ngay.slice(5, 7)}/${ngay.slice(0, 4)}`,
  conTiemGiuMaCu: (n: number) => `${n} tiệm bạn không chọn vẫn dùng mã cũ.`,
  oMaMoi: 'Mã mới',
  oMaMoiLai: 'Nhập lại mã mới',
  maKhongKhop: 'Hai lần nhập mã mới chưa giống nhau.',
  luuMaMoi: 'Lưu mã mới',
  xongTieuDe: 'Đã đổi mã',
  xongGoiY: 'Mọi máy đang đăng nhập bằng mã cũ đã được đăng xuất. Bạn đăng nhập bằng mã mới nhé.',
  // Còn tiệm giữ mã cũ (`conLai > 0`): chỉ máy vào các tiệm vừa chọn bị đăng xuất — không nói "mọi máy" cạnh câu "n tiệm vẫn dùng mã cũ".
  xongGoiYMotPhan:
    'Máy đang vào các tiệm bạn vừa chọn đã được đăng xuất. Hãy đăng nhập bằng mã mới nhé.',
  xongNut: 'Đăng nhập',
  khongNhanDuoc: 'Không nhận được mã? Nhắn SAPA',

  daiZalo: (ten: string, luc: string) =>
    `Mã đăng nhập của ${ten} vừa được đặt lại qua Zalo lúc ${luc}.`,
  daiSapa: (ten: string, luc: string) => `SAPA vừa đặt lại mã đăng nhập của ${ten} lúc ${luc}.`,
  // v0.23.1 (ADR-123): việc NGƯỜI TRONG TIỆM làm tới một chủ — cùng đuôi `daiKhongPhai` và nút `daiDaBiet`.
  daiCapChu: (ai: string, ten: string, luc: string) =>
    `${ai} vừa giao vai Chủ tiệm cho ${ten} lúc ${luc}.`,
  daiBoChu: (ai: string, ten: string, luc: string) =>
    `${ai} vừa bỏ vai Chủ tiệm của ${ten} lúc ${luc}.`,
  daiChoNghiChu: (ai: string, ten: string, luc: string) =>
    `${ai} vừa cho chủ tiệm ${ten} nghỉ lúc ${luc}.`,
  daiDiLamLaiChu: (ai: string, ten: string, luc: string) =>
    `${ai} vừa cho chủ tiệm ${ten} đi làm lại lúc ${luc}.`,
  daiDatMaChu: (ai: string, ten: string, luc: string) =>
    `${ai} vừa đặt lại mã đăng nhập của ${ten} lúc ${luc}.`,
  daiDoiSoChu: (ai: string, ten: string, luc: string) =>
    ai === ten
      ? `${ten} vừa đổi số đăng nhập lúc ${luc}.`
      : `${ai} vừa đổi số đăng nhập của ${ten} lúc ${luc}.`,
  daiKhongPhai: 'Không phải người trong tiệm làm? Gọi SAPA ngay.',
  // v0.23.2 (B-V2): việc tới Quản lý / Lễ tân. Người làm là chính người đang xem -> "Bạn vừa …" + đuôi `daiKhongPhaiBan`.
  // N2 (vòng sửa 1): dấu cách KHÔNG ngắt (U+00A0) giữa hai âm tiết — dải 320–390px không ngắt dòng ở "Quản / lý", "Lễ / tân".
  tenVaiDai: { manager: 'Quản lý', cashier: 'Lễ tân' },
  // B2-L1: dòng nhật ký không có người làm (`pnpm db:dat-ma`, `actor_id` NULL). "Ai đó" thay vì "SAPA": không biết chắc là ai, và câu
  // "SAPA vừa … Gọi SAPA ngay" tự mâu thuẫn; đuôi "Không phải người trong tiệm làm? Gọi SAPA ngay." đã đủ hướng dẫn.
  daiAiDo: 'Ai đó',
  daiThemNguoi: (ai: string, vai: string, ten: string, luc: string) =>
    `${ai} vừa thêm ${vai} ${ten} lúc ${luc}.`,
  daiGiaoVai: (ai: string, vai: string, ten: string, luc: string) =>
    `${ai} vừa giao vai ${vai} cho ${ten} lúc ${luc}.`,
  daiDatMaNguoi: (ai: string, vai: string, ten: string, luc: string) =>
    `${ai} vừa đặt mã đăng nhập cho ${vai} ${ten} lúc ${luc}.`,
  daiDoiSoNguoi: (ai: string, vai: string, ten: string, luc: string) =>
    `${ai} vừa đổi số đăng nhập của ${vai} ${ten} lúc ${luc}.`,
  daiDiLamLaiNguoi: (ai: string, vai: string, ten: string, luc: string) =>
    `${ai} vừa cho ${vai} ${ten} đi làm lại lúc ${luc}.`,
  daiBan: 'Bạn',
  daiKhongPhaiBan: 'Không phải bạn làm? Gọi SAPA ngay.',
  daiDaBiet: 'Đã biết',

  chonTiemTieuDe: 'Bạn vào tiệm nào?',
  chonTiemGoiY: 'Số điện thoại này làm ở nhiều tiệm. Bạn chọn tiệm muốn vào.',
  dongPhuTiem: (tenVai: string, ma: string) =>
    [tenVai, ma === '' ? '' : `mã ${ma}`].filter(Boolean).join(' · '),
  dangVao: 'Đang vào…',
} as const
